<div class="bookmark-popup">
    <button class="close-button" (click)="closePopup()">✖</button>
    <div class="icon-container">
      <mat-icon class="bookmark-icon"></mat-icon>
    </div>
    <h2>{{ message }}</h2>
    <button class="watchlist-button" (click)="goToWatchlist()">Go to My Watchlist</button>
</div>
  